import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Annulleret',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Modtaget',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Bekræftet',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'Under tilberedning',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'På vej',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Klar',
  status: {
    actual: 'Nuværende',
    pending: 'Afventer',
  },
  warning_label: {
    pickup_time_changed: '{{company}} har ændret tidspunktet fra {{initialTime}} til {{currentTime}}',
  },
  labels: {
    order_number: 'Ordrenr.: {{number}}',
    today: 'I dag',
  },
};
